import React, { useEffect, useRef, useState } from 'react';
import dynamic from 'next/dynamic';
import { buildClassName } from 'utils/build-class-name';
import MenuButton from 'components/header/menu-button';
import ThemedIcon from 'components/themed-icon';
import styles from './style.module.scss';
import { headerIds, testIds } from 'constants/test-constants';
import Button from 'components/control/button';
import { useIsMobile } from 'hooks/use-size-class';
import UserIcon from 'components/icon/user-icon';
import expCommercialTenant from 'tenants/definitions/exp-commercial.tenant';

type CommercialHeaderProps = {
  showHeader?: boolean;
}

const CommercialHeader = ({ showHeader = true }: CommercialHeaderProps) => {
  const tenant = expCommercialTenant;
  const { menuItems } = tenant.config.header;
  const [menuDropdownIsActive, setMenuDropdownIsActive] = useState(false);
  const [Dropdown, setDropdown] = useState<any>();
  const closeDropdownTimeoutRef = useRef<number | null>(null);

  useEffect(() => {
    return () => {
      if (closeDropdownTimeoutRef.current) {
        clearTimeout(closeDropdownTimeoutRef.current);
      }
    };
  }, []);

  const toggleMenuDropdown = () => {
    if (!Dropdown) {
      setDropdown(dynamic(import('components/dropdown')));
    }
    setMenuDropdownIsActive(prev => !prev);
  };

  const isMobile = useIsMobile();

  return (
    <div className={buildClassName(styles.component, !showHeader && styles['hide-header'])} data-testid={headerIds.header}>
      <div className={buildClassName(styles['layout-container'])}>
        <div className={buildClassName(styles['logo-wrapper'])}>
          <a href="https://www.expcommercial.com" className={styles.logo} rel="noreferrer"><ThemedIcon /></a>
        </div>
        <div className={styles.navigation}>
          {menuItems.map((link, index) => <a key={index} href={link.link} className={buildClassName(styles['menu-item'])}>{link.label}</a>)}
          <Button 
            label={!isMobile ? 'Advisor Sign In' : ''} 
            Icon={isMobile && UserIcon} theme={'secondary'} 
            className={styles['advisory-button']} 
            onClick={() => window.open('https://www.expcommercial.com/advisor-center', '_blank')}
          />
          <MenuButton className={styles.menu} testId={testIds.menuButton} onClick={toggleMenuDropdown} closeMenu={() => setMenuDropdownIsActive(false)}>
            <>
              <div className={styles['bar-container']} id="menu">
                <span className={buildClassName(styles.bar, menuDropdownIsActive && styles.x)} />
                <span className={buildClassName(styles.bar, menuDropdownIsActive && styles.x)} />
              </div>
              {menuDropdownIsActive && Dropdown && <Dropdown items={menuItems} />}
            </>
          </MenuButton>
        </div>
      </div>
    </div>
  );
};

export default CommercialHeader;
